import { DevToolsContext } from '../context/context';
import { useContext } from 'react';

const useDevTools = () => {
  return useContext(DevToolsContext);
};

export default useDevTools;
